<script setup lang="ts">
const props = defineProps<{
  title?: string
  gray?: boolean
}>()
</script>

<template>
  <section class="py-20 2xl:py-28" :class="{ 'bg-neutral-100': props.gray }">
    <div class="container">
      <slot name="title">
        <UiSectionTitle v-if="props.title" :title="props.title" />
      </slot>
      <slot></slot>
    </div>
  </section>
</template>
